import React, { useState, useEffect } from "react";
import { baseUrl } from '../../shared.js';
import '../App.css';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import { Toggle } from '../../components/ui';
import Typography from '@mui/material/Typography';
import Autocomplete from '@mui/material/Autocomplete';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from "@mui/x-date-pickers";
import moment from 'moment';
import dayjs from 'dayjs';
  
function Create() {
  const [changed, setChanged] = useState(false);
  const [newAsset, setNewAsset] = useState();
  var [assetTypes, setAssetTypes] = useState([]);
  const [assetTypesLoaded, setAssetTypesLoaded] = useState(false);
  var [companies, setCompanies] = useState([]);
  const [companiesLoaded, setCompaniesLoaded] = useState(false);
  var [capacities, setCapacities] = useState([]);
  const [capacitiesLoaded, setCapacitiesLoaded] = useState(false);
  var [descriptions, setDescriptions] = useState([]);
  const [descriptionsLoaded, setDescriptionsLoaded] = useState(false);
  var [makes, setMakes] = useState([]);
  const [makesLoaded, setMakesLoaded] = useState(false);
  var [maxHeights, setMaxHeights] = useState([]);
  const [maxHeightsLoaded, setMaxHeightsLoaded] = useState(false);
  var [models, setModels] = useState([]);
  const [modelsLoaded, setModelsLoaded] = useState(false);
  var [siteLocations, setSiteLocations] = useState([]);
  const [siteLocationsLoaded, setSiteLocationsLoaded] = useState(false);
  var [companyAcId, setCompanyAcId] = useState();
  var [newCatKey, setNewCatKey] = useState();

  const date = {
    now: dayjs().format('YYYY-MM-DD')
  };


useEffect(()=> {
  console.log(changed);
  console.log('New Asset ',newAsset);
});

const [responseOpen, setResponseOpen] = React.useState(false);
const [message, setMessage] = useState('');

                               
useEffect(()=> {
  if (localStorage.getItem('canAddAsset') === '1' ) {
    
  } else {
    window.location.href='/'
  }
},[]);

const handleResponseClose = () => {
setResponseOpen(false);
window.location.href='/?assetNo='+[newAsset.assetId]
};

async function createAsset(e) {
  e.preventDefault();
  const url = baseUrl;
  await fetch(url, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'username': localStorage.getItem('username'),
          'bToken': localStorage.getItem('bToken')
      },
      body: JSON.stringify(newAsset),
  })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data.status === 200) {
          setMessage(data.message);
          setResponseOpen(true);
          } else if (data.status === 401) {
            setMessage(data.message);
            setResponseOpen(true);
          }
        })
        .catch((err) => {
          setMessage(err.message);
          setResponseOpen(true);
        });
}

const loadAssetTypes = async () => {
    const url = baseUrl + 'asset/typeAc/';
      await fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        }})
        .then((res) => {
          return res.json();
      }).then((json) => {
          setAssetTypes(json);
          console.log('Types Loaded ', assetTypes)
      })
      .catch((err) => {
        setAssetTypesLoaded(false);
         console.log(err.message);
      });
    }

const loadCompanies = async () => {
    const url = baseUrl + 'company/listAc/';
      await fetch(url, {
        method: 'GET',
        headers: {
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        }})
        .then((res) => {
          return res.json();
      }).then((json) => {
          console.log('companies ',json)
          setCompanies(json);
          setCompanyAcId(`${Math.floor((Math.random() * 1000))}-min`);
          console.log('companies named ',companies)
      })
      .catch((err) => {
        setCompaniesLoaded(false);
         console.log(err.message);
      });
    }

const loadCapacities = async () => {
      const url = baseUrl + 'asset/capacityAc/';
        await fetch(url, {
          method: 'GET',
          headers: {
              'username': localStorage.getItem('username'),
              'bToken': localStorage.getItem('bToken')
          }})
          .then((res) => {
            return res.json();
        }).then((json) => {
            console.log(json)
            setCapacities(json);
        })
        .catch((err) => {
          setCapacitiesLoaded(false);
           console.log(err.message);
        });
      }

const loadDescriptions = async () => {
        const url = baseUrl + 'asset/descriptionAc/';
          await fetch(url, {
            method: 'GET',
            headers: {
                'username': localStorage.getItem('username'),
                'bToken': localStorage.getItem('bToken')
            }})
            .then((res) => {
              return res.json();
          }).then((json) => {
              console.log(json)
              setDescriptions(json);
          })
          .catch((err) => {
            setDescriptionsLoaded(false);
             console.log(err.message);
          });
        }

const loadMakes = async () => {
          const url = baseUrl + 'asset/makeAc/';
            await fetch(url, {
              method: 'GET',
              headers: {
                  'username': localStorage.getItem('username'),
                  'bToken': localStorage.getItem('bToken')
              }})
              .then((res) => {
                return res.json();
            }).then((json) => {
                console.log(json)
                setMakes(json);
            })
            .catch((err) => {
              setMakesLoaded(false);
               console.log(err.message);
            });
          }

const loadMaxHeights = async () => {
            const url = baseUrl + 'asset/maxHeightAc/';
              await fetch(url, {
                method: 'GET',
                headers: {
                    'username': localStorage.getItem('username'),
                    'bToken': localStorage.getItem('bToken')
                }})
                .then((res) => {
                  return res.json();
              }).then((json) => {
                  console.log(json)
                  setMaxHeights(json);
              })
              .catch((err) => {
                setMaxHeightsLoaded(false);
                 console.log(err.message);
              });
            }

const loadSiteLocations = async () => {
              const url = baseUrl + 'asset/siteLocationAc/';
                await fetch(url, {
                  method: 'GET',
                  headers: {
                      'username': localStorage.getItem('username'),
                      'bToken': localStorage.getItem('bToken')
                  }})
                  .then((res) => {
                    return res.json();
                }).then((json) => {
                    console.log(json)
                    setSiteLocations(json);
                })
                .catch((err) => {
                  setSiteLocationsLoaded(false);
                   console.log(err.message);
                });
              }

const loadModels = async () => {
              const url = baseUrl + 'asset/modelAc/';
                await fetch(url, {
                  method: 'GET',
                  headers: {
                      'username': localStorage.getItem('username'),
                      'bToken': localStorage.getItem('bToken')
                  }})
                  .then((res) => {
                    return res.json();
                }).then((json) => {
                    console.log(json)
                    setModels(json);
                })
                .catch((err) => {
                  setModelsLoaded(false);
                   console.log(err.message);
                });
              }
          
useEffect(() => {
  if (!assetTypesLoaded ) {
    setAssetTypesLoaded(true)
    loadAssetTypes()
  }
  if (!companiesLoaded ) {
    setCompaniesLoaded(true)
    loadCompanies()
  }
  if (!capacitiesLoaded ) {
    setCapacitiesLoaded(true)
    loadCapacities()
  }
  if (!descriptionsLoaded ) {
    setDescriptionsLoaded(true)
    loadDescriptions()
  }
  if (!makesLoaded ) {
    setMakesLoaded(true)
    loadMakes()
  }
  if (!maxHeightsLoaded ) {
    setMaxHeightsLoaded(true)
    loadMaxHeights()
  }
  if (!siteLocationsLoaded ) {
    setSiteLocationsLoaded(true)
    loadSiteLocations()
  }
  if (!modelsLoaded ) {
    setModelsLoaded(true)
    loadModels()
  }
})

return (
    <div>
      <React.Fragment>
      <Dialog
        open={responseOpen}
        onClose={handleResponseClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="confirmResponseTitle">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmResponseDesc">
            [{message}]
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResponseClose}>OK</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>

    <Box sx={{ maxWidth: 620, mx: 'auto', width: '100%', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: 'var(--shadow-sm)', p: { xs: 2, sm: 3 } }}>
    <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.25 }}>Create New Asset</Typography>
    <Typography variant="body2" sx={{ color: 'var(--muted)', mb: 2 }}>Fill out the fields below to create a new asset in the system.</Typography>
     <Box
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="catNo" 
          required
          label="Catalogue Number" 
          variant="outlined" 
          type="text" 
          onChange={(e) => {
            setChanged(true);
            setNewAsset({
               ...newAsset,
            catNo: e.target.value,
            newCat: 1,
            });
            setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
            }}
        />
     </Box>
        <Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="assetId" 
          required
          label="Asset Number" 
          variant="outlined" 
          type="text" 
          onChange={(e) => {
            setChanged(true);
            setNewAsset({
               ...newAsset,
            assetId: e.target.value,
            newCat: 1,
            });
            setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
            }}
        />
     </Box>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  id={companyAcId}
  options={companies}
  onChange={(e) => {
    setChanged(true);
    setNewAsset({
       ...newAsset,
    customer: e.target.innerHTML,
    newCat: 1,
    });
    setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Customer" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  id="typeAc"
  options={assetTypes}
  onChange={(e) => {
    setChanged(true);
    setNewAsset({
       ...newAsset,
    type: e.target.innerHTML,
    newCat: 1,
    });
    setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Type" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  id="siteLocationAc"
  options={siteLocations}
  onChange={(e) => {
    setChanged(true);
    setNewAsset({
       ...newAsset,
    siteLocation: e.target.innerHTML,
    newCat: 1,
    });
    setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Site Location" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  options={descriptions}
  onChange={(e) => {
    setChanged(true);
    setNewAsset({
       ...newAsset,
    item: e.target.innerHTML,
    newCat: 1,
    });
    setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Item" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  options={makes}
  onChange={(e) => {
    setChanged(true);
    setNewAsset({
       ...newAsset,
    manufacturer: e.target.innerHTML,
    newCat: 1,
    });
    setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Manufacturer" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  options={models}
  onChange={(e) => {
    setChanged(true);
    setNewAsset({
       ...newAsset,
    model: e.target.innerHTML,
    newCat: 1,
    });
    setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Model" />}
    />
  </FormControl>
     <Box 
          margin="dense">
         <TextField 
        fullWidth
          margin="dense"
          id="serialNo" 
          label="Serial Number" 
          variant="outlined" 
          type="text" 
          onChange={(e) => {
            setChanged(true);
            setNewAsset({
               ...newAsset,
            serialNo: e.target.value,
            newCat: 1,
            });
            setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
            }}
        />
     </Box>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  options={maxHeights}
  onChange={(e) => {
    setChanged(true);
    setNewAsset({
       ...newAsset,
    maxHeight: e.target.innerHTML,
    newCat: 1,
    });
    setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Max Height" />}
    />
  </FormControl>
     <FormControl
          margin="dense"
     fullWidth>
     <Autocomplete
     required
  disablePortal
  disableClearable
  id="typeAc"
  options={capacities}
  onChange={(e) => {
    setChanged(true);
    setNewAsset({
       ...newAsset,
    capacity: e.target.innerHTML,
    newCat: 1,
    });
    setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
    }}
    renderInput={(params) => <TextField {...params} label="Capacity" />}
    />
  </FormControl>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
     <MobileDatePicker 
        slotProps={{ textField: { fullWidth: true } }}
        sx={{ mt: 1, mb: 1 }}
        margin="dense"
        id="buildDate" 
        label="Build Date"
        variant="outlined" 
        format="DD-MM-YYYY"
        defaultValue={dayjs(date.now)}
        onChange={(e) => {
          setChanged(true);
          setNewAsset({
             ...newAsset,
          buildDate: (moment(e).format('YYYY-MM-DD') === 'Invalid date' ) ? '-' : moment(e).format('YYYY-MM-DD'),
          newCat: 1,
          });
          setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
        }}
      />
     <MobileDatePicker 
        slotProps={{ textField: { fullWidth: true } }}
        sx={{ mt: 1, mb: 1 }}
        margin="dense"
        id="expiringCalibrationDate" 
        label="Calibration Expiry Date"
        variant="outlined" 
        format="DD-MM-YYYY"
        defaultValue={dayjs(date.now)}
        onChange={(e) => {
          setChanged(true);
          setNewAsset({
             ...newAsset,
          expiringCalibrationDate: (moment(e).format('YYYY-MM-DD') === 'Invalid date' ) ? '-' : moment(e).format('YYYY-MM-DD'),
          modifiedCat: 1,
          });
          setNewCatKey(`${Math.floor((Math.random() * 1000))}-min`);
        }}
      />
     </LocalizationProvider>
     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', my: 1 }}>
       <Typography variant="body2" sx={{ fontWeight: 600 }}>New Asset Setup</Typography>
       <Toggle
         checked={Number(newAsset?.newCat) === 1}
         onChange={() => {
           setChanged(true);
           setNewAsset({ ...newAsset, newCat: Number(newAsset?.newCat) === 1 ? 0 : 1 });
         }}
       />
     </Box>
     
{changed && newAsset.assetId && newAsset.catNo ? ( <form
                        className="w-full max-w-sm"
                        id="asset"
                        onClick={createAsset}
                    >
                        <div className="mb-2">
                            <Button variant="contained"
                                form="asset"
                            >
                                Create Cat No.
                            </Button>
                        </div>
                        </form>
                        
                    ) : null
                  }    
                  <div className="mb-2">
                  <Button variant="outlined"
                      onClick={(e) => {
                          window.location.href='/'
                      }}
                  >
                      Cancel Asset Creation
                  </Button>
              </div>
        </Box>
  </div>
)};

export default Create